// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TextEraserIconSignature {
  Element: SVGSVGElement;
}

export const TextEraserIcon: TOC<TextEraserIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.292 18.707C6.474 18.888 6.724 19 7 19H13C13.276 19 13.526 18.888 13.708 18.707L21 11.414C21.78 10.635 21.78 9.36599 21 8.58599L15.414 2.99999C14.635 2.21999 13.365 2.21999 12.586 2.99999L3 12.586C2.22 13.366 2.22 14.635 3 15.414L6.292 18.707ZM2 20H22V22H2V20ZM15.586 14L10 8.41399L4.414 14L7.414 17H12.586L15.586 14Z"/>
</svg>
</template>;